/* =========================================================================
   ボタンクリック・ページ滞在の計測（2026-10-05、10-06 改訂）
   すべてのボタン・リンクのクリックと、ページの表示・滞在秒数・スクロール位置を、当社の集計サーバー（window.FAG_TRACK.url）へ送る。
   送るのはページ種別・ボタン名・流入元・訪問ごとのランダム ID のみ。氏名・メール・入力内容は送らない。
   ボタンの固定 ID は data-track 属性（無ければ「場所:表示名」から自動で作る）。一覧は docs/tracking-inventory.md。
   2026-10-06: 注文へ閲覧経路を書き込む機能（カート属性）は廃止。集計はレポート側で行う。
   ========================================================================= */
(function () {
  "use strict";
  var SESSION = "fag_session", VISITS = "fag_visits", GAP = 30 * 60 * 1000;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var TRACK = window.FAG_TRACK || {};

  function get(k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }
  function set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function rid(n) { var s = ""; while (s.length < n) s += Math.random().toString(36).slice(2); return s.slice(0, n); }
  function clean(s, n) {
    s = String(s || "").replace(/\s+/g, " ").replace(/Unitree\s*[（(]ユニツリー[)）]\s*/g, "").trim();
    return s.length > n ? s.slice(0, n) + "…" : s;
  }
  function last(q, k) { var v = q.getAll(k); return v.length ? v[v.length - 1] : ""; }
  function refHost() { try { return document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : ""; } catch (e) { return ""; } }

  /* 流入元。フィードの URL には無料リスティング用の UTM が先に付くので、UTM は最後の値を読む */
  function source() {
    var q = new URLSearchParams(location.search), host = refHost();
    var med = last(q, "utm_medium").toLowerCase(), camp = last(q, "utm_campaign"), src = last(q, "utm_source");
    var campLabel = camp && camp !== "sag_organic" ? "(" + clean(camp, 24) + ")" : "";
    if (q.get("gclid") || q.get("gbraid") || q.get("wbraid")) return "Google広告" + campLabel;
    if (q.get("ttclid")) return "TikTok広告" + campLabel;
    if (/^(cpc|ppc|paid|paidsocial)$/.test(med)) return (/facebook|instagram|meta/i.test(src) ? "Meta" : clean(src || "", 12)) + "広告" + campLabel;
    if (camp === "sag_organic") return "Google無料リスティング";
    if (src) return clean(src + (med ? "/" + med : ""), 30);
    if (!host || host === location.hostname.replace(/^www\./, "")) return "直接";
    if (/(^|\.)google\./.test(host)) return "Google検索";
    if (/yahoo\./.test(host)) return "Yahoo検索";
    if (/bing\.com$/.test(host)) return "Bing検索";
    if (/chatgpt\.com$|openai\.com$/.test(host)) return "ChatGPT";
    if (/instagram\.com$/.test(host)) return "Instagram";
    if (/facebook\.com$/.test(host)) return "Facebook";
    if (/tiktok\.com$/.test(host)) return "TikTok";
    if (/(^|\.)(t\.co|x\.com|twitter\.com)$/.test(host)) return "X";
    if (/youtube\.com$|youtu\.be$/.test(host)) return "YouTube";
    if (/amazon\./.test(host)) return "Amazon";
    return clean(host, 30);
  }

  /* ---- 訪問（30 分空くか、広告・SNS から来直したら新しい訪問）---- */
  var now = Date.now(), ses = get(SESSION, null);
  var external = refHost() !== location.hostname.replace(/^www\./, "");
  var tagged = /[?&](gclid|gbraid|wbraid|fbclid|ttclid|utm_source)=/.test(location.search);
  if (!ses || !ses.sid || now - ses.t > GAP || (tagged && external)) {
    ses = { t: now, src: source(), sid: rid(10) };
    set(VISITS, (get(VISITS, 0) || 0) + 1);
  }
  ses.t = now;
  set(SESSION, ses);
  var visits = get(VISITS, 1) || 1, page = clean(window.FAG_PAGE || document.title, 34);
  if (window.clarity) { try { window.clarity("set", "流入", ses.src); window.clarity("set", "訪問回数", String(visits)); } catch (e) {} }

  /* 2026-10-06: 以前の版がカートに書き込んだ「閲覧経路」などの属性が残っていれば消す（1 訪問に 1 回だけ確認） */
  try {
    if (!sessionStorage.getItem("fag_attr_checked")) {
      sessionStorage.setItem("fag_attr_checked", "1");
      fetch(ROOT + "cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (c) {
        var a = (c && c.attributes) || {};
        if (a["閲覧経路"] != null || a["訪問回数"] != null) {
          fetch(ROOT + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ attributes: { "訪問回数": "", "初回の流入": "", "今回の流入": "", "閲覧経路": "" } }) }).catch(function () {});
        }
      }).catch(function () {});
    }
  } catch (e) {}

  /* ---- 集計サーバーへの送信（クリック・表示・滞在）---- */
  var PV = rid(8), bot = navigator.webdriver || /bot|crawl|spider|headless|lighthouse/i.test(navigator.userAgent);
  function beacon(evs) {
    if (!TRACK.url || bot) return;
    var body = JSON.stringify({ env: TRACK.env || "preview", page: page, src: ses.src, sid: ses.sid, vis: visits, pv: PV, e: evs });
    try { if (navigator.sendBeacon && navigator.sendBeacon(TRACK.url, body)) return; } catch (e) {}
    try { fetch(TRACK.url, { method: "POST", body: body, keepalive: true }).catch(function () {}); } catch (e) {}
  }
  beacon([{ k: "view" }]);

  /* 滞在秒数は「画面に表示されていた時間」の合計。タブを離れるたびに累計を送り、集計側で表示ごとの最大値を採る */
  var shown = document.visibilityState === "visible" ? Date.now() : 0, total = 0, maxScroll = 0, sentAt = -1;
  function scrolled() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.round((window.scrollY || window.pageYOffset || 0) / h * 100) : 100;
    if (p > maxScroll) maxScroll = Math.min(p, 100);
  }
  function leave() {
    if (shown) { total += Date.now() - shown; shown = 0; }
    scrolled();
    var sec = Math.round(total / 1000);
    if (sec === sentAt || sec < 1) return;
    sentAt = sec;
    beacon([{ k: "leave", dur: sec, scroll: maxScroll }]);
  }
  window.addEventListener("scroll", scrolled, { passive: true });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") leave(); else if (!shown) shown = Date.now();
  });
  window.addEventListener("pagehide", leave);

  /* ---- クリックの分類 ---- */
  function zone(el) {
    if (el.closest("#CartDrawer, .cart-drawer")) return "カート";
    if (el.closest(".nav")) return "ナビ";
    if (el.closest(".hero")) return "ヒーロー";
    if (el.closest(".sns")) return "SNS";
    if (el.closest(".endorse, #videoModal")) return "紹介動画";
    if (el.closest("footer")) return "フッター";
    return "本文";
  }
  function textOf(el) {
    var href = el.getAttribute("href") || "";
    if (/\/products\//.test(href) && !el.closest(".nav")) return "商品カード";
    return clean((el.getAttribute("data-track-label") || el.getAttribute("aria-label") || el.textContent || el.value || "").replace(/[→›»↗]/g, ""), 16);
  }
  function productName(el) {
    var card = el.closest(".pcard, .acc-card") || el, t = card.querySelector(".pcard__title, .ptitle, h3, img[alt]");
    var s = t ? (t.textContent || t.getAttribute("alt") || "") : "";
    if (!s.trim()) { try { s = decodeURIComponent((el.getAttribute("href") || "").split("/products/")[1].split(/[?#]/)[0]); } catch (e) {} }
    return clean(s, 22);
  }
  /* 計測用: { tid: 固定 ID, zone: 場所, label: 表示名, href: 外部リンク先 } */
  function describe(el, kind, label) {
    var z = zone(el), marked = el.closest("[data-track]"), href = "", ext = false;
    if (el.tagName === "A" && el.hostname && el.hostname !== location.hostname) { ext = true; href = (el.href || "").split("?")[0]; }
    var name = label || textOf(el), card = "";
    if (!label && name === "商品カード") {  // 商品へのリンクは商品ハンドルを ID にする（一覧・関連商品・カート内で同じ商品は同じ ID）
      name = "商品カード「" + productName(el) + "」";
      try { card = "card:" + decodeURIComponent((el.getAttribute("href") || "").split("/products/")[1].split(/[?#]/)[0]).slice(0, 48); } catch (e) {}
    }
    var tid = marked ? marked.getAttribute("data-track") : kind ? kind : card ? card : "auto:" + z + ":" + name;
    if (marked && marked.getAttribute("data-track-label")) name = marked.getAttribute("data-track-label");
    return { k: "click", tid: tid, zone: z, label: name, href: ext ? href : "" };
  }
  /* 専用の ID を持つ操作。[セレクタ, 固定 ID, 表示名] */
  var RULES = [
    ["[data-qty-minus],[data-qty-plus]", "pdp:qty", "数量の変更"],
    ["[data-line-plus],[data-line-minus]", "cart:qty", "カート内の数量変更"],
    ["[data-cart-close]", "cart:close", "カートを閉じる"],
    [".pdp2__thumb", "pdp:thumb", "商品画像の切替"],
    [".nav-amazon", "nav:amazon", "Amazonで購入"],
    ["[data-cart-open]", "nav:cart", "カートを開く"],
    ["[data-line-remove]", "cart:remove", "カートから削除"]
  ];
  function special(el) {
    for (var i = 0; i < RULES.length; i++) if (el.matches(RULES[i][0])) return { tid: RULES[i][1], label: RULES[i][2] };
    if (el.matches("[data-atc]")) {
      if (!el.closest(".pdp2")) return { tid: "card:atc", label: "カートに追加「" + productName(el) + "」" };  // 一覧・アクセサリページの商品カード上のボタン
      var v = document.querySelector(".pdp2__swatch.is-on");
      return { tid: "pdp:atc", label: "カートに追加" + (v ? ":" + clean(v.textContent, 22) : "") };
    }
    if (el.matches("[name='checkout']") || (el.tagName === "A" && /\/checkout/.test(el.getAttribute("href") || ""))) return { tid: "cart:checkout", label: "レジに進む" };
    if (el.matches(".pdp2__swatch")) return { tid: "pdp:swatch", label: "選択:" + clean(el.textContent, 22) };
    return null;
  }
  /* 一覧作成用（scripts/tracking_inventory.py）: 要素がクリックされたときに送られる内容を返す */
  function inspect(el) { var sp = special(el); return describe(el, sp && sp.tid, sp && sp.label); }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(".pdp2__paybtn, .shopify-payment-button")) { beacon([{ k: "click", tid: "pdp:buynow", zone: "本文", label: "今すぐ購入", href: "" }]); return; }
    var el = t.closest("a, button, summary, [role='button'], input[type='submit']");
    if (!el) return;
    var sp = special(el);
    if (sp) { beacon([describe(el, sp.tid, sp.label)]); return; }
    if (el.tagName === "A") {
      var href = el.getAttribute("href") || "";
      if (el.hostname && el.hostname !== location.hostname) { beacon([describe(el)]); return; }
      if (href && href.charAt(0) !== "#") { beacon([describe(el)]); return; }
    }
    if (textOf(el)) beacon([describe(el)]);
  }, true);

  /* テーマの他のスクリプトから任意の操作を記録する（例: SNS 欄の動画再生） */
  function track(tid, z, label, href) { beacon([{ k: "click", tid: tid, zone: z || "本文", label: label || tid, href: href || "" }]); }
  window.FAGJourney = { inspect: inspect, track: track, session: function () { return { src: ses.src, sid: ses.sid, visits: visits }; } };
})();
